// ComboBoxAutoComplete.js
import React from "react";
import { Autocomplete, TextField, CircularProgress } from "@mui/material";
import "../homeHero.css";

const CustomCompleteBox = ({
  placeholder,
  options,
  value,
  inputValue,
  onInputChange,
  onChange,
  getOptionLabel = (opt) => (typeof opt === "string" ? opt : opt.title || ""),
  isLoading = false,
  error = "",
  useSearchStyle = false, // new prop
}) => {
  // decide which class to apply to the actual <input>
  const inputClass = useSearchStyle ? "results_search__input" : "hero__input";

  return (
    <div className="combo-box-autocomplete" style={{ flex: 1 }}>
      <Autocomplete
        freeSolo
        fullWidth
        disableClearable
        options={options}
        getOptionLabel={getOptionLabel}
        value={value}
        inputValue={inputValue}
        loading={isLoading}
        onInputChange={(_, v) => onInputChange(v)}
        onChange={(_, v) => onChange(v)}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            variant="outlined"
            error={Boolean(error)}
            helperText={error}
            fullWidth
            sx={{
              m: 0,
              p: 0,
              "& .MuiFormControl-root": { m: 0, p: 0 },
              "& .MuiOutlinedInput-root": {
                m: 0,
                p: 0,
                border: "none",
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
                "& fieldset": {
                  m: 0,
                  p: 0,
                },
                "& .MuiOutlinedInput-input": {
                  m: 0,
                  p: 0,
                  height: "auto",
                  // if we're NOT using search style, keep Poppins 20
                  ...(useSearchStyle
                    ? {}
                    : { fontFamily: "Poppins", fontSize: "20px" }),
                },
              },
              "& .MuiFormHelperText-root": { m: 0, p: 0 },
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {isLoading && <CircularProgress size={20} />}
                  {params.InputProps.endAdornment}
                </>
              ),
              inputProps: {
                ...params.inputProps,
                className: inputClass,
                style: { padding: 0, margin: 0, height: "auto" },
              },
            }}
          />
        )}
      />
    </div>
  );
};

export default CustomCompleteBox;
